import { makeAutoObservable } from "mobx";
import { deleteProfession, getProfessionById, pagingProfession, saveProfession, } from 'app/services/ProfessionService';
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { Profession } from "app/common/Model/Profession";
import { checkSearchObject } from "app/common/LocalFunction";
import { PAGESIZE_ALL } from "app/common/LocalConst";

export default class ProfessionStore {
    listAllProfession = [];
    searchProfession = new SearchObject();
    pageProfession = null;
    selectedProfession = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteProfession = false;

    constructor() {
        makeAutoObservable(this);
    }

    getAllProfession = async () => {
        if (this.listAllProfession?.length === 0) {
            pagingProfession({ pageIndex: 1, pageSize: PAGESIZE_ALL }).then(({ data }) => this.listAllProfession = data?.content);
        }
    }

    pagingProfession = () => {
        pagingProfession(this.searchProfession).then(({ data }) => {
            this.pageProfession = data;
        })
    }

    handleChangeFormSearch = (searchProfession) => {
        this.searchProfession = checkSearchObject(this.searchProfession, searchProfession);
        this.pagingProfession();
    }

    handleOpenFormCreateOrEdit = (professionId) => {
        if (Boolean(professionId)) {
            getProfessionById(professionId).then(({ data }) => {
                this.selectedProfession = data;
                this.openFormCreateOrEdit = true;
            })
        } else {
            this.selectedProfession = new Profession();
            this.openFormCreateOrEdit = true;
        }
    }

    saveProfession = (profession, { setSubmitting }) => {
        saveProfession(profession).then(() => {
            this.selectedProfession = null;
            toast.success("Lưu nghề nghiệp thành công!");
            this.handleClosePopup();
            this.pagingProfession()
        }).finally(() => setSubmitting(false))
    }

    handleDeleteProfession = (profession) => {
        this.selectedProfession = { id: profession?.id };
        this.openConfirmDeleteProfession = true;
    }

    handleConfirmDeleteProfession = () => deleteProfession(this.selectedProfession?.id)
        .then(() => {
            if (this.searchProfession.pageIndex > 1 && this.pageProfession.content.length === 1) {
                this.searchProfession.pageIndex -= 1;
            }
            toast.success("Xóa nghề nghiệp thành công!")
            this.handleClosePopup();
            this.pagingProfession();
        })
        .catch(error => {
            console.error(error);
            toast.error("Xóa nghề nghiệp có lỗi");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteProfession = false;
    }

    resetStore = () => {
        this.searchProfession = new SearchObject();
        this.pageProfession = null;
        this.selectedProfession = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteProfession = false;
    }
}
